import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="108.5" height="108.5" viewBox="0 0 108.5 108.5"> <path d="M1.75-42A54.25,54.25,0,0,0,56,12.25,54.25,54.25,0,0,0,110.25-42,54.25,54.25,0,0,0,56-96.25,54.25,54.25,0,0,0,1.75-42ZM56-1.75v-80.5A40.228,40.228,0,0,1,96.25-42,40.228,40.228,0,0,1,56-1.75Z" transform="translate(-1.75 96.25)"/></svg>
  )
